








import { Watch, Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import biReportPreview from "../tool/biReport/preview.vue";
import util from "@/lib/util";

@Component({
  components: { biReportPreview },
})
export default class App extends AbpBase {
  message = "";

  @Watch("message")
  messageChange(curVal: any, oldVal: any) {
    console.log(curVal, oldVal);
  }

  get HomeTemplate() {
    return util.abp.setting.get("HomeTemplate");
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/home/home.vue